import React, {Component} from 'react';

export default class PopupSubMenu extends Component{
    render(){
        return(
            <li>
                <button className={'subMenuToggle' + (this.props.subMenus[this.props.target]?' open':'')} onClick={() => this.props.onClick()}>
                    {this.props.subMenus[this.props.target]?'^':'v'}
                </button>
                {this.props.subMenus[this.props.target] &&
                <ul className="subMenu">
                    {this.props.children}
                </ul>
                }
            </li>
        );
    }
}


// WEBPACK FOOTER //
// ./src/js/studio/ui/popupSubMenu.js